<script setup lang="ts">
/** Section « Documents disponibles » (capture DT, section 9). */
import { DocumentDuplicateIcon } from '@heroicons/vue/24/outline'
import type { AccompDocument } from '@/v2/accompagnement/api/accompagnementTypes'
import { ACCOMP_DOCUMENT_OPTIONS } from '@/v2/accompagnement/constants/accompagnementConstants'

const documents = defineModel<AccompDocument[]>('documents', { required: true })

function toggle(value: AccompDocument, checked: boolean) {
  const set = new Set(documents.value)
  if (checked) set.add(value)
  else set.delete(value)
  documents.value = [...set]
}
</script>

<template>
  <section class="card border border-base-300 bg-base-100 shadow-sm" aria-labelledby="accomp-docs-title">
    <div class="card-body gap-3 p-4 md:p-6">
      <h2 id="accomp-docs-title" class="card-title flex items-center gap-2 text-lg font-semibold">
        <DocumentDuplicateIcon class="h-5 w-5 text-primary" aria-hidden="true" />
        Documents disponibles
      </h2>
      <p class="text-sm text-base-content/70">Cochez les documents que le client peut fournir.</p>
      <div class="grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2">
        <label
          v-for="opt in ACCOMP_DOCUMENT_OPTIONS"
          :key="opt.value"
          class="flex cursor-pointer items-center gap-2"
        >
          <input
            type="checkbox"
            class="checkbox checkbox-primary checkbox-sm"
            :checked="documents.includes(opt.value)"
            @change="toggle(opt.value, ($event.target as HTMLInputElement).checked)"
          />
          <span class="text-base">{{ opt.label }}</span>
        </label>
      </div>
    </div>
  </section>
</template>
